import React from "react";


const BackGround = () => {


    return (
        <center>
        <div class="fondo">
        </div>
        </center>
    )
}

export default BackGround 